var _classCallCheck = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

// from https://github.com/ConnextProject/connext-client/blob/master/src/helpers/MerkleTree.js
var Buffer = require('buffer').Buffer;

var keccak256 = require('js-sha3').keccak256;

function combinedHash(first, second) {
  if (!second) {
    return first;
  }

  if (!first) {
    return second;
  }

  var sorted = Buffer.concat([first, second].sort(Buffer.compare));
  return Buffer.from(keccak256.arrayBuffer(sorted));
}

function deduplicate(buffers) {
  // NOTE: performance?
  return buffers.filter(function (buffer, i) {
    return buffers.findIndex(function (e) {
      return e.equals(buffer);
    }) === i;
  });
}

function getPair(index, layer) {
  var pairIndex = index % 2 ? index - 1 : index + 1;

  if (pairIndex < layer.length) {
    return layer[pairIndex];
  }

  return null;
}

function getLayers(elements) {
  if (elements.length === 0) {
    return [[Buffer.from('')]];
  }

  var layers = [];
  layers.push(elements);

  while (layers[layers.length - 1].length > 1) {
    layers.push(getNextLayer(layers[layers.length - 1]));
  }

  return layers;
}

function getNextLayer(elements) {
  return elements.reduce(function (layer, element, index, arr) {
    if (index % 2 === 0) {
      layer.push(combinedHash(element, arr[index + 1]));
    }

    return layer;
  }, []);
}

var MerkleTree = /*#__PURE__*/function () {
  "use strict";

  function MerkleTree(_elements) {
    _classCallCheck(this, MerkleTree);

    if (!_elements.every(function (b) {
      return b.length === 32 && Buffer.isBuffer(b);
    })) {
      throw new Error('elements must be 32 byte buffers');
    }

    var e = {
      elements: deduplicate(_elements)
    };
    Object.assign(this, e);
    this.elements.sort(Buffer.compare);
    var l = {
      layers: getLayers(this.elements)
    };
    Object.assign(this, l);
  }

  _createClass(MerkleTree, [{
    key: "getRoot",
    value: function getRoot() {
      if (!this.root) {
        var r = {
          root: this.layers[this.layers.length - 1][0]
        };
        Object.assign(this, r);
      }

      return this.root;
    }
  }, {
    key: "verify",
    value: function verify(proof, element) {
      return this.getRoot().equals(proof.reduce(function (hash, pair) {
        return combinedHash(hash, pair);
      }, element));
    }
  }, {
    key: "proof",
    value: function proof(element) {
      var index = this.elements.findIndex(function (e) {
        return e.equals(element);
      });

      if (index === -1) {
        throw new Error('element not found in merkle tree');
      }

      return this.layers.reduce(function (proof, layer) {
        var pair = getPair(index, layer);

        if (pair) {
          proof.push(pair);
        }

        index = Math.floor(index / 2);
        return proof;
      }, []);
    }
  }]);

  return MerkleTree;
}();

module.exports = MerkleTree;